import { getAllCotizaciones, getAllCotizacionesPaginacion, getCotizacionesRevisionAdminAll, getCotizacionPdf, putAceptarCotizacionAgente, putAceptarCotizacionAgenteSupervisor, putActulizarVigenciaCotizacion, putCompletarCotizacionProceso, putDeclinarCotizacionAgente, putDeclinarCotizacionAgenteEdit, putDeclinarCotizacionAgenteSupervisor, putRenviarCotizacionAgente } from "../services/cotizacionService"
import { getIneCotizaicion } from "../services/documentosService"
const dataInicial = {
    listaCotizaciones: [],
    cotizaciones: [],
    busquedaCotizacion: 0,
    total: 0,
    pagina: 0,
    registroPagina: 10,
    exito: 0,
    cotizacionesReview: [],
    documentINE: []
}
const GET_COTIZACIONES_ALL = "GET_COTIZACIONES_ALL"
const GET_COTIZACIONES_ALL_LISTA = "GET_COTIZACIONES_ALL_LISTA"
const GET_COTIZACIONES_BUSQUEDA = "GET_COTIZACIONES_BUSQUEDA"
const GET_COTIZACIONES_REGISTROS_PAGINA = "GET_COTIZACIONES_REGISTROS_PAGINA"
const GET_COTIZACIONES_PAGINA = "GET_COTIZACIONES_PAGINA"
const POST_COTIZACIONES_EXITO = "POST_COTIZACIONES_EXITO"
const GET_COTIZACIONES_PDF = "GET_COTIZACIONES_PDF"
const PUT_COTIZACIONES_ACEPTAR_AGENTE = "PUT_COTIZACIONES_ACEPTAR_AGENTE"
const PUT_COTIZACIONES_DECLINAR_COTIZACION = "PUT_COTIZACIONES_DECLINAR_COTIZACION"
const PUT_COTIZACIONES_REENVIAR_COTIZACION = "PUT_COTIZACIONES_REENVIAR_COTIZACION"
const PUT_COTIZACIONES_REENVIAR_COTIZACION_EDIT = "PUT_COTIZACIONES_REENVIAR_COTIZACION_EDIT"
const PUT_COTIZACIONES_FINALIZAR_PROCESO_COTIZACION = "PUT_COTIZACIONES_FINALIZAR_PROCESO_COTIZACION"
const PUT_COTIZACIONES_ACTULIZAR_VIGENCIA = "PUT_COTIZACIONES_ACTULIZAR_VIGENCIA"

const GET_COTIZACIONES_ALL_REVIEW_ACTION = "GET_COTIZACIONES_ALL_REVIEW_ACTION"
const PUT_COTIZACIONES_REVIEW_ACEPTAR_ACTION = "PUT_COTIZACIONES_REVIEW_ACEPTAR_ACTION"
const PUT_COTIZACIONES_REVIEW_DECLINAR_ACTION = "PUT_COTIZACIONES_REVIEW_DECLINAR_ACTION"

const GET_COTIZACIONES_INE_DOCUEMENT = "GET_COTIZACIONES_INE_DOCUEMENT"
export default function cotizacionesReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_COTIZACIONES_INE_DOCUEMENT:
            return { ...state, documentINE: action.payload.documentINE }
        case PUT_COTIZACIONES_REVIEW_ACEPTAR_ACTION:
            return { ...state, exito: action.payload.exito }
        case PUT_COTIZACIONES_REVIEW_DECLINAR_ACTION:
            return { ...state, exito: action.payload.exito }
        case GET_COTIZACIONES_ALL_REVIEW_ACTION:
            return { ...state, cotizacionesReview: action.payload.cotizacionesReview }
        case PUT_COTIZACIONES_ACTULIZAR_VIGENCIA:
            return { ...state, exito: action.payload.exito }
        case PUT_COTIZACIONES_FINALIZAR_PROCESO_COTIZACION:
            return { ...state, exito: action.payload.exito }
        case PUT_COTIZACIONES_REENVIAR_COTIZACION_EDIT:
            return { ...state, exito: action.payload.exito }
        case PUT_COTIZACIONES_REENVIAR_COTIZACION:
            return { ...state, exito: action.payload.exito }
        case PUT_COTIZACIONES_DECLINAR_COTIZACION:
            return { ...state, exito: action.payload.exito }
        case PUT_COTIZACIONES_ACEPTAR_AGENTE:
            return { ...state, exito: action.payload.exito }
        case GET_COTIZACIONES_PDF:
            return { ...state, exito: action.payload.exito }
        case POST_COTIZACIONES_EXITO:
            return { ...state, exito: action.payload.exito }
        case GET_COTIZACIONES_BUSQUEDA:
            return {
                ...state,
                busquedaCotizacion: action.payload.busquedaCotizacion,
                cotizaciones: action.payload.cotizaciones,
                total: action.payload.total,
                pagina: action.payload.pagina,
                registroPagina: action.payload.registroPagina
            }
        case GET_COTIZACIONES_ALL_LISTA:
            return { ...state, listaCotizaciones: action.payload.listaCotizaciones }
        case GET_COTIZACIONES_ALL:
            return {
                ...state,
                cotizaciones: action.payload.cotizaciones,
                total: action.payload.total,
            }
        case GET_COTIZACIONES_PAGINA:
            return {
                ...state,
                cotizaciones: action.payload.cotizaciones,
                total: action.payload.total,
                pagina: action.payload.pagina,
            }
        case GET_COTIZACIONES_REGISTROS_PAGINA:
            return {
                ...state,
                cotizaciones: action.payload.cotizaciones,
                total: action.payload.total,
                registroPagina: action.payload.registroPagina
            }
        default:
            return state;
    }
}
//* Metodo para obtener la INE por idCotizacion
export const clearObtenerINECotizacionAction = () => (dispatch) => {
    dispatch({
        type: GET_COTIZACIONES_INE_DOCUEMENT,
        payload: {
            documentINE: dataInicial.documentINE,
        },
    })
}
export const obtenerINECotizacionAction = ({ idCotizacion }) => async (dispatch) => {
    return await getIneCotizaicion({ idCotizacion }).then(Response => {
        dispatch({
            type: GET_COTIZACIONES_INE_DOCUEMENT,
            payload: {
                documentINE: Response,
            },
        });
        return Response
    }).catch(Error => {
        return []
    })
}
/** Cotizaciones review */
export const obtenerCotizacionesReviewAction = () => async (dispatch, getSate) => {
    return await getCotizacionesRevisionAdminAll().then(Response => {
        dispatch({
            type: GET_COTIZACIONES_ALL_REVIEW_ACTION,
            payload: {
                cotizacionesReview: Response,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const aceptarCotizacionReviewAction = ({ IdCotizacion }) => async (dispatch, getSate) => {
    return await putAceptarCotizacionAgenteSupervisor({ idCotizacion: IdCotizacion }).then(Response => {
        dispatch({
            type: PUT_COTIZACIONES_REVIEW_ACEPTAR_ACTION,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const declinarCotizacionReviewAction = ({ IdCotizacion }) => async (dispatch, getSate) => {
    return await putDeclinarCotizacionAgenteSupervisor({ idCotizacion: IdCotizacion }).then(Response => {
        dispatch({
            type: PUT_COTIZACIONES_REVIEW_DECLINAR_ACTION,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
/** Fin cotizaciones review */

export const actulizarVigenciaCotizacionAction = ({ idCotizacion, fechaExpiracion }) => async (dispatch) => {
    return await putActulizarVigenciaCotizacion({ FechaExpiracion: fechaExpiracion, idCotizacion }).then(Response => {
        dispatch({
            type: PUT_COTIZACIONES_ACTULIZAR_VIGENCIA,
            payload: {
                exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerBusquedaAction = ({ busqueda }) => async (dispatch, getSate) => {
    return await getAllCotizacionesPaginacion({ IdCotizacion: busqueda.IdCotizacion, Pagina: dataInicial.pagina + 1, Registros: dataInicial.registroPagina }).then(Response => {
        dispatch({
            type: GET_COTIZACIONES_BUSQUEDA,
            payload: {
                cotizaciones: Response.lCotizacion,
                total: Response.Total,
                busquedaCotizacion: busqueda.IdCotizacion,
                pagina: dataInicial.pagina,
                registroPagina: dataInicial.registroPagina
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const completarCotizacionProcesoAction = ({ IdCotizacion }) => async (dispatch) => {
    return await putCompletarCotizacionProceso({ idCotizacion: IdCotizacion }).then(Response => {
        dispatch({
            type: PUT_COTIZACIONES_FINALIZAR_PROCESO_COTIZACION,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const declinarCotizacionAgenteEditarAction = ({ IdCotizacion }) => async (dispatch) => {
    return await putDeclinarCotizacionAgenteEdit({ idCotizacion: IdCotizacion }).then(Response => {
        dispatch({
            type: PUT_COTIZACIONES_REENVIAR_COTIZACION_EDIT,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const reenviarCotizacionAgenteAction = ({ IdCotizacion }) => async (dispatch) => {
    return await putRenviarCotizacionAgente({ idCotizacion: IdCotizacion }).then(Response => {
        dispatch({
            type: PUT_COTIZACIONES_REENVIAR_COTIZACION,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const declinarCotizacionAgenteAction = ({ IdCotizacion }) => async (dispatch) => {
    return await putDeclinarCotizacionAgente({ idCotizacion: IdCotizacion }).then(Response => {
        dispatch({
            type: PUT_COTIZACIONES_DECLINAR_COTIZACION,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const aceptarCotizacionAgenteAction = ({ IdCotizacion }) => async (dispatch) => {
    return await putAceptarCotizacionAgente({ idCotizacion: IdCotizacion }).then(Response => {
        dispatch({
            type: PUT_COTIZACIONES_ACEPTAR_AGENTE,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerCotizacionPdfAction = ({ IdCotizacion }) => async (dispatch) => {
    return await getCotizacionPdf({ IdCotizacion }).then(Response => {
        dispatch({
            type: GET_COTIZACIONES_PDF,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerListaCotizacionesAction = () => async (dispatch) => {
    return await getAllCotizaciones({}).then(Response => {
        dispatch({
            type: GET_COTIZACIONES_ALL_LISTA,
            payload: {
                listaCotizaciones: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerCotizacionesAction = () => async (dispatch, getSate) => {
    const { pagina, registroPagina, busquedaCotizacion } = getSate().cotizaciones
    return await getAllCotizacionesPaginacion({ IdCotizacion: busquedaCotizacion, Pagina: pagina + 1, Registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_COTIZACIONES_ALL,
            payload: {
                cotizaciones: Response.lCotizacion,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obteneCotizacionesRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { pagina } = getSate().cotizaciones
    return await getAllCotizacionesPaginacion({ IdCotizacion: dataInicial.busquedaCotizacion, Pagina: pagina + 1, Registros }).then(Response => {
        dispatch({
            type: GET_COTIZACIONES_REGISTROS_PAGINA,
            payload: {
                cotizaciones: Response.lCotizacion,
                total: Response.Total,
                registroPagina: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerCotizacionesPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { registroPagina } = getSate().cotizaciones
    return await getAllCotizacionesPaginacion({ IdCotizacion: dataInicial.busquedaCotizacion, Pagina: Pagina + 1, Registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_COTIZACIONES_PAGINA,
            payload: {
                cotizaciones: Response.lCotizacion,
                total: Response.Total,
                pagina: Pagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
